// Navigation Icon Component
// Dynamic icon component using Lucide React

import React from 'react';
import {
  LayoutDashboard,
  Server,
  Play,
  Clock,
  Copy,
  Activity,
  DollarSign,
  BarChart3,
  Bell,
  User,
  CreditCard,
  Settings,
  Key,
  ChevronRight,
  ChevronDown,
  Menu,
  X,
  LucideIcon
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  LayoutDashboard,
  Server,
  Play,
  Clock,
  Copy,
  Activity,
  DollarSign,
  BarChart3,
  Bell,
  User,
  CreditCard,
  Settings,
  Key,
  ChevronRight,
  ChevronDown,
  Menu,
  X
};

interface NavigationIconProps {
  name: string;
  size?: number;
  className?: string;
  color?: string;
}

export const NavigationIcon: React.FC<NavigationIconProps> = ({
  name,
  size = 20,
  className = '',
  color = 'currentColor'
}) => {
  const IconComponent = iconMap[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in iconMap`);
    return null;
  }

  return (
    <IconComponent
      size={size}
      color={color}
      className={className}
    />
  );
};